module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    class: {
      'c-card qa-multicard': _vm.hasMultipleCards
    }
  }, [(_vm.hasMultipleCards) ? _c('div', {
    staticClass: "c-card__multicard-header"
  }, [_c('menu', {
    staticClass: "c-card__multicard-header__menu qa-multicard-dropdown"
  }, [_c('menuitem', {
    staticClass: "c-card__multicard-header__menu__default t-headline qa-multicard-menu-button",
    class: _vm.showDropdown == true ? 'is-open' : '',
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.card.title) + ": " + _vm._s(_vm.currentCard.title))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-down"
  })]), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "c-card__multicard-header__menu__itemgroup"
  }, _vm._l((_vm.card.card_layout), function(card, index) {
    return (typeof _vm.cards[card.id] !== 'undefined') ? _c('menuitem', {
      staticClass: "c-card__multicard-header__menu__menuitem qa-multicard-menuitem",
      class: _vm.showDropdown == true ? 'is-open' : '',
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.cards[card.id].title))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentCardIndex),
        expression: "index === currentCardIndex"
      }],
      staticClass: "fa fa-check t-headline"
    })]) : _vm._e()
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), (typeof _vm.currentCard !== 'undefined' && typeof _vm.currentCard.id !== 'undefined') ? _c('card-' + _vm.currentCard.type, {
    key: _vm.currentCard.id,
    tag: "component",
    staticClass: "qa-multicard-current",
    attrs: {
      "card": _vm.currentCard,
      "loaded": !_vm.loading
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65932074"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/MultiCard.vue
// module id = 546
// module chunks = 1